import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { SearchIcon } from "@/shared/icons";
import type { InputProps } from "antd";
import type { FC } from "react";
import { AppInput } from "../AppInput";
import { AppButton } from "../../AppButton";
import styles from "./styles.module.scss";

type Props = InputProps & {
  className?: string;
};

export const InputSearch: FC<Props> = ({ className, ...rest }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <AppInput
        addonAfter={
          <AppButton
            type="text"
            icon={<SearchIcon className={styles["search-icon"]} />}
            className={classNames(styles["button-search"])}
          />
        }
        className={classNames(styles.search, className)}
        placeholder={t("common.search")}
        {...rest}
      />
    </div>
  );
};
